/**
 * Per-user coupon codes saved from My Account (localStorage).
 * Checkout shows these for one-tap apply; nothing applies until the user clicks Apply.
 */

const STORAGE_PREFIX = 'sheenwear_saved_coupon_codes';

function storageKey(userId) {
  return `${STORAGE_PREFIX}:${userId == null ? 'guest' : String(userId)}`;
}

export function normalizeSavedCouponCode(code) {
  return String(code || '').trim().toUpperCase();
}

export function getSavedCouponCodes(userId) {
  if (userId == null || userId === '') return [];
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return [...new Set(arr.map(normalizeSavedCouponCode).filter(Boolean))];
  } catch {
    return [];
  }
}

export function addSavedCouponCode(userId, code) {
  const c = normalizeSavedCouponCode(code);
  if (!c || userId == null || userId === '') return getSavedCouponCodes(userId);
  const cur = getSavedCouponCodes(userId);
  if (!cur.includes(c)) cur.push(c);
  localStorage.setItem(storageKey(userId), JSON.stringify(cur));
  window.dispatchEvent(new CustomEvent('sheenwearSavedCouponsUpdated'));
  return cur;
}

export function removeSavedCouponCode(userId, code) {
  const c = normalizeSavedCouponCode(code);
  const cur = getSavedCouponCodes(userId).filter((x) => x !== c);
  localStorage.setItem(storageKey(userId), JSON.stringify(cur));
  window.dispatchEvent(new CustomEvent('sheenwearSavedCouponsUpdated'));
  return cur;
}
